import { Warehouse } from "@secondcloset/types";

type ReturnStatusMap = { [status in Warehouse.ReturnStatus]: string };

export const statusTagColorConfig: ReturnStatusMap = {
  READY_TO_PROCESS: "processing",
  NEEDS_REVIEW: "error",
  ARRIVED: "processing",
  PROCESSING: "warning",
  REQUESTED: "error",
  ON_HOLD: "error",
  TO_BE_RESHIPPED: "success",
  COMPLETED: "success",
  CANCELLED: "warning",
};

export enum ReturnType {
  RTS = "RTS",
  REGULAR = "REGULAR",
}

export enum ReturnStatus {
  READY_TO_PROCESS = "READY_TO_PROCESS",
  NEEDS_REVIEW = "NEEDS_REVIEW",
  ARRIVED = "ARRIVED",
  PROCESSING = "PROCESSING",
  REQUESTED = "REQUESTED",
  ON_HOLD = "ON_HOLD",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
  TO_BE_RESHIPPED = "TO_BE_RESHIPPED",
}
